import { Component, OnInit } from '@angular/core';

import { DealerService } from '../../../dealer/services/dealer.service';

@Component({
  selector: 'app-dealer-logo',
  templateUrl: './dealer.logo.component.html',
  styleUrls: ['./dealer.logo.component.scss']
})
export class DealerLogoComponent implements OnInit {

  isLogoLoading: boolean;
  logoError: boolean;
  dealerLogo: any;
  errors: string;

  constructor(private dealerService: DealerService) {
  }

  ngOnInit() {
    this.isLogoLoading = true;

    this.dealerService.getDealerLogo()
      .subscribe({
        next: (data) => {
          this.convertBase64FromBlob(data);
          this.isLogoLoading = false;
        },
        error: (error: string) => {
          this.isLogoLoading = false;
          this.logoError = true;
          this.errors = error;
        }
      });
  }

  convertBase64FromBlob(image: Blob): void {
    let reader = new FileReader();
    reader.addEventListener("load", () => {
      this.dealerLogo = reader.result;
    }, false);

    if (image) {
      reader.readAsDataURL(image);
    }
  }
}
